import {InternalModule} from './module';
import {ApiBridge} from '../api-bridge';
import {PersonInfo} from '../../model/person-info';
import {ConversationType} from '../../model/conversation-type';
import {IndividualUiState} from '../../model/individualui_state';
import {NewConversationInterceptor} from "../../unblu-api";
import {ConversationInfo} from "../../model/conversation-info";

export type GeneralEventType =
    'activeConversationChange' |
    'conversationsChange' |
    'notificationCountChange' |
    'personChange' |
    'uiStateChange';

const enum GeneralFunction {
    startConversation = 'startConversation',
    setNewConversationInterceptor = 'setNewConversationInterceptor',
    joinConversation = 'joinConversation',
    openConversation = 'openConversation',
    toggleIndividualUi = 'toggleIndividualUi',
    popoutIndividualUi = 'popoutIndividualUi',
    popinIndividualUi = 'popinIndividualUi',
    maximizeIndividualUi = 'maximizeIndividualUi',
    minimizeIndividualUi = 'minimizeIndividualUi',
    openIndividualUi = 'openIndividualUi',
    openPinEntryUi = 'openPinEntryUi',
    collapseIndividualUi = 'collapseIndividualUi',
    getIndividualUiState = 'getIndividualUiState',
    getActiveConversation = 'getActiveConversation',
    getConversations = 'getConversations',
    getNotificationCount = 'getNotificationCount',
    getPersonInfo = 'getPersonInfo',
    setPersonNickname = 'setPersonNickname'
}

export class GeneralModule extends InternalModule<GeneralFunction, GeneralEventType> {
    constructor(bridge: ApiBridge) {
        super(bridge, 'general');
    }

    public startConversation(type: ConversationType, visitorName?: string, visitorData?: string): Promise<string> {
        return this.callApiFunction(GeneralFunction.startConversation, [type, visitorName, visitorData]);
    }

    public setNewConversationInterceptor(callback: NewConversationInterceptor): Promise<void> {
        return this.callApiFunction(GeneralFunction.setNewConversationInterceptor, [callback]);
    }

    public joinConversation(pin: string, visitorName?: string): Promise<string> {
        return this.callApiFunction(GeneralFunction.joinConversation, [pin, visitorName]);
    }

    public openConversation(conversationId: string): Promise<void> {
        return this.callApiFunction(GeneralFunction.openConversation, [conversationId]);
    }

    public toggleIndividualUi(): Promise<void> {
        return this.callApiFunction(GeneralFunction.toggleIndividualUi, []);
    }

    public openPinEntryUi(): Promise<void> {
        return this.callApiFunction(GeneralFunction.openPinEntryUi, []);
    }

    public popoutIndividualUi(): Promise<void> {
        return this.callApiFunction(GeneralFunction.popoutIndividualUi, []);
    }

    public popinIndividualUi(): Promise<void> {
        return this.callApiFunction(GeneralFunction.popinIndividualUi, []);
    }

    public maximizeIndividualUi(): Promise<void> {
        return this.callApiFunction(GeneralFunction.maximizeIndividualUi, []);
    }

    public minimizeIndividualUi(): Promise<void> {
        return this.callApiFunction(GeneralFunction.minimizeIndividualUi, []);
    }

    public openIndividualUi(): Promise<void> {
        return this.callApiFunction(GeneralFunction.openIndividualUi, []);
    }

    public collapseIndividualUi(): Promise<void> {
        return this.callApiFunction(GeneralFunction.collapseIndividualUi, []);
    }

    public getIndividualUiState(): Promise<IndividualUiState> {
        return this.callApiFunction(GeneralFunction.getIndividualUiState, []); 
    }

    public getActiveConversation(): Promise<string> {
        return this.callApiFunction(GeneralFunction.getActiveConversation, []);
    }

    public getConversations(): Promise<ConversationInfo[]> {
        return this.callApiFunction(GeneralFunction.getConversations, []);
    }

    public getNotificationCount(): Promise<number> {
        return this.callApiFunction(GeneralFunction.getNotificationCount, []);
    }

    public getPersonInfo(): Promise<PersonInfo> {
        return this.callApiFunction(GeneralFunction.getPersonInfo, []);
    }

    public setPersonNickname(nickname: string): Promise<void> {
        return this.callApiFunction(GeneralFunction.setPersonNickname, [nickname]);
    }
}